import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import flagIndia from '../resources/icons/flag-icon-india.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    height: 15,
    display: 'inline-flex',
    userSelect: 'none',

    [theme.breakpoints.up('md')]: {
      marginLeft: 12,
    },

    img: {
      display: 'block',
    },
  },
}));

const FlagIcon = ({ className = '' }) => {
  const classes = useStyles();

  return (
    <span className={`${classes.root} ${className}`}>
      <img src={flagIndia} alt="flag-icon-india" />
    </span>
  );
};

export default FlagIcon;
